import { Icon } from '@buggy/shared'
import React, { FunctionComponent } from 'react'
import styled from 'styled-components'

export interface ArrowPaginationButtonsProps {
  currentPage: number
  totalPage: number
  onChange: (page: number) => void
  className?: string
  isDemo?: boolean
}

const ArrowPaginationButtons: FunctionComponent<
  ArrowPaginationButtonsProps
> = ({ currentPage, totalPage, onChange, className, isDemo }) => {
  const prePageDisabled = currentPage === 1 || isDemo
  const nextPageDisabled = currentPage === totalPage || isDemo

  return (
    <ButtonsWrapper className={className}>
      <ArrowButton
        disabled={prePageDisabled}
        onClick={(): void => {
          !prePageDisabled && onChange(currentPage - 1)
        }}
      >
        <Icon fontSize={12} name='chevron-left' />
      </ArrowButton>
      <ArrowButton
        disabled={nextPageDisabled}
        onClick={(): void => {
          !nextPageDisabled && onChange(currentPage + 1)
        }}
      >
        <Icon fontSize={12} name='chevron-right' />
      </ArrowButton>
    </ButtonsWrapper>
  )
}

const ArrowButton = styled((props) => <div {...props} />)<{
  disabled: boolean
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: ${({ theme }): string => theme.colors.background.white};
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  cursor: ${({ disabled }): string => (disabled ? 'default' : 'pointer')};
  opacity: ${({ disabled }): number => (disabled ? 0.5 : 1)};
`

const ButtonsWrapper = styled.div`
  width: fit-content;
  gap: 10px;
`

export default styled(ArrowPaginationButtons)``
